<lms-modal #deleteClientModal size="small">
  <div class="gl-popup__close" (click)="deleteClientModal.close()">
    <span data-testid="deleteClientModalClose" class="glicon-close"></span>
  </div>

  <div class="gl-popup__icon error centered">
    <span class="glicon-alert-thin"></span>
  </div>

  <div class="gl-popup__title centered">
    {{ (action === 'deleteInfo' ? 'clients.confirmDeleteInfoTitle' : 'clients.confirmDeleteTitle') | translate }}
  </div>

  <ng-container [ngSwitch]="action">
    <ng-container *ngSwitchCase="'delete'">
      <ng-container *ngIf="client.hasActiveData; else deleteTemplate">
        <div
          class="gl-popup__text"
          [innerHTML]="'clients.deleteActiveDataMessage' | translate : { client: client.name }"
        ></div>
        <ng-container
          *ngTemplateOutlet="accountSummaryTemplate; context: { accountSummary: client.accountSummary }"
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="partnerAccountSummaryTemplate; context: { partnerSummary: client.partnerSummary }"
        ></ng-container>
      </ng-container>
      <ng-template #deleteTemplate>
        <div
          class="gl-popup__text"
          [innerHTML]="'clients.confirmDeleteMessage' | translate : { client: client.name }"
        ></div>
      </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'deleteInfo'">
      <div class="gl-popup__text" [innerHTML]="'clients.confirmDeleteInfoMessage' | translate : deleteInfoData"></div>
      <div
        *ngIf="client.partnerSummary?.isPartner"
        class="gl-popup__text"
        [innerHTML]="
          'clients.confirmDeletePartnerInfoMessage' | translate : { admins: client.partnerSummary.adminsCount }
        "
      ></div>
    </ng-container>
  </ng-container>

  <div *ngIf="client.hasActiveData" class="gl-popup__field">
    <gl-checkbox
      *ngIf="canDelete"
      data-testid="deleteClientCheck"
      [id]="'client.checkDelete'"
      [label]="'clients.confirmDeleteCheck' | translate"
      [attr.small]="true"
      skeletorValueAccessor
      [checked]="confirmDeleteCheck"
      [(ngModel)]="confirmDeleteCheck"
    >
    </gl-checkbox>
  </div>
  <div *ngIf="!client.hasActiveData" class="gl-popup__text alert">
    {{ 'clients.confirmDeleteAlert' | translate }}
  </div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="deleteClientModal.close()"></gl-button>
    <gl-button
      data-testid="deleteClientButton"
      [disabled]="client.hasActiveData && !confirmDeleteCheck"
      color-primary
      [text]="(action === 'deleteInfo' ? 'actions.deleteClientData' : 'actions.deleteClient') | translate"
      (onClick)="confirmDelete()"
    ></gl-button>
  </div>
</lms-modal>

<!-- PLANTILLAS -->
<ng-template #activeIconTemplate let-flag="flag">
  <ng-container *ngIf="flag; else inactive">
    <gl-icon style="color: var(--aqua-marine)" icon="glicon-check"></gl-icon>
  </ng-container>
  <ng-template #inactive>
    <gl-icon style="color: var(--coral)" icon="glicon-close"></gl-icon>
  </ng-template>
</ng-template>

<!-- en caso de ser necesario llevar esto a su propio componente -->
<ng-template #accountSummaryTemplate let-accountSummary="accountSummary">
  <ul class="margin-left">
    <li>
      {{ 'pageTitle.students' | translate }}: {{ accountSummary.usersCount }} ({{
        accountSummary.identifiedUsersCount
      }}
      {{ 'students.notAninonymizedStudents' | translate }})
    </li>
    <li>{{ 'pageTitle.agents' | translate }}: {{ accountSummary.adminsCount }}</li>
    <li>{{ 'pageTitle.groups' | translate }}: {{ accountSummary.groupsCount }}</li>
    <li>
      {{ 'subscriptions.active' | translate }}:
      <ng-container
        *ngTemplateOutlet="activeIconTemplate; context: { flag: accountSummary.hasActiveSubscriptions }"
      ></ng-container>
    </li>
    <li>
      {{ 'nouns.editorAccess' | translate }}:
      <ng-container
        *ngTemplateOutlet="activeIconTemplate; context: { flag: accountSummary.hasEditorAccess }"
      ></ng-container>
      <span *ngIf="accountSummary.hasEditorAccess && accountSummary.hasStripe"
        >({{ 'clients.stripeLinked' | translate }})</span
      >
    </li>
    <li *ngIf="accountSummary.hasProductivityMatches">
      Kepler:
      <ng-container *ngTemplateOutlet="activeIconTemplate; context: { flag: true }"></ng-container>
    </li>
  </ul>
</ng-template>

<ng-template #partnerAccountSummaryTemplate let-partnerSummary="partnerSummary">
  <ng-container *ngIf="partnerSummary?.isPartner">
    <div class="gl-popup__text" [innerHTML]="'clients.isPartnerMessage' | translate : { client: client.name }"></div>
    <ul class="margin-left">
      <li>{{ 'pageTitle.clients' | translate }}: {{ partnerSummary.clientsCount }}</li>
      <li>{{ 'pageTitle.agents' | translate }}: {{ partnerSummary.adminsCount }}</li>
      <li>
        {{
          (client?.partner?.subscriptions?.users ? 'distributors.balanceSeats' : 'distributors.creditsBalance')
            | translate
        }}:
        {{ partnerSummary.brokerBalanceAmount }}
      </li>
    </ul>
  </ng-container>
</ng-template>
